import { render } from "./PrivacypolicyView.vue?vue&type=template&id=0562de70&lang=html"
import script from "./PrivacypolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacypolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__